import { Injectable, signal } from '@angular/core';

import { WidgetRepresentation } from './dashboard-widget.model';

@Injectable({ providedIn: 'root' })
export class DashboardPrefsService {
  private readonly KEY = 'arrow_dashboard_representations';

  /** widgetId → chosen representation. Reactive so hosts recompute on change. */
  readonly reps = signal<Record<string, WidgetRepresentation>>(this.load());

  /** The user's override for a widget, or undefined to fall back to the default. */
  get(widgetId: string): WidgetRepresentation | undefined {
    return this.reps()[widgetId];
  }

  /** Record a choice and persist it. */
  set(widgetId: string, rep: WidgetRepresentation): void {
    const next = { ...this.reps(), [widgetId]: rep };
    this.reps.set(next);
    try {
      localStorage.setItem(this.KEY, JSON.stringify(next));
    } catch {
      /* storage unavailable — keep the in-memory choice for this session */
    }
  }

  private load(): Record<string, WidgetRepresentation> {
    try {
      return JSON.parse(localStorage.getItem(this.KEY) ?? '{}');
    } catch {
      return {};
    }
  }
}
